import React from 'react';
import { Button, Form, Input, Row, Col, Select } from 'antd';
import { observer, inject } from 'mobx-react';
const FormItem = Form.Item;
import Title from '@/components/Title';
import styles from './Report.less';
import ReportTable from '@/components/Report/ReportTable';
import { formatDeviceId } from '../../lib/lib';
import { formItemLayout } from '../../const/FormConst';
import { buildUrl, fetch } from '../../lib/fetchAPI';

const { Option } = Select;
const { Search } = Input;

@inject('reportStore')
@observer
class ReportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clients: [],
      clientId: '',
      onlineStatus: ''
    };
    this.deviceId = '';
    this.download = this.download.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
  }
  componentDidMount() {
    this.props.reportStore.loadReport();
    this.loadClients();
  }
  componentWillUnmount() {
    this.props.form.resetFields();
    this.props.reportStore.reportDate = [];
    this.props.reportStore.reportDateTotal = 1;
    this.props.reportStore.page_num = 1;
  }

  loadClients() {
    fetch('/api/report/clients', { method: 'GET' }).then(clients =>
      this.setState({ clients })
    );
  }

  onChangePage(pageNumber) {
    this.props.reportStore.page_num = pageNumber;
    this.handleSubmit(false);
  }

  setClientId = clientId => {
    this.setState({ clientId }, () => this.handleSubmit(true));
  };

  setOnlineStatus = onlineStatus => {
    this.setState({ onlineStatus }, () => this.handleSubmit(true));
  };

  handleSubmit(resetPage) {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.deviceId = formatDeviceId(value.deviceId).join(',');
        if (resetPage) {
          this.props.reportStore.page_num = 1;
        }
        this.props.reportStore.loadReport(
          this.deviceId,
          this.state.clientId,
          this.state.onlineStatus
        );
      }
    });
  }

  async download() {
    let fileUrl = await this.props.reportStore.downloadReport(
      this.deviceId,
      this.state.clientId,
      this.state.onlineStatus
    );
    let a = document.createElement('a');
    a.href = fileUrl;
    a.download = `report`;
    a.click();
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { page_num } = this.props.reportStore;
    const { clients, clientId, onlineStatus } = this.state;
    return (
      <div className={styles.Report}>
        <Title
          titleText={'搜索条件'}
          btn={{
            text: '报表下载',
            func: this.download,
            state: this.props.reportStore.reportDate.length
          }}
        />
        <div className={styles.searchContainer}>
          <Form onSubmit={e => e.preventDefault()}>
            <Row className={styles.rowContainer}>
              <Col span={6}>
                <FormItem {...formItemLayout} label="客户">
                  <Select value={clientId} onChange={this.setClientId}>
                    <Option value={''}>全部</Option>
                    {clients.map(c => (
                      <Option key={c.id} value={c.id}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              </Col>
              <Col span={4}>
                <FormItem {...formItemLayout} label="设备状态">
                  <Select value={onlineStatus} onChange={this.setOnlineStatus}>
                    <Option value={''}>全部</Option>
                    <Option value={1}>在线</Option>
                    <Option value={0}>离线</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span={5} offset={8}>
                <FormItem>
                  {getFieldDecorator('deviceId', {
                    rules: [
                      {
                        pattern: /^[0-9A-F,]*$/,
                        message: '请输入0~9,A~F!'
                      }
                    ]
                  })(
                    <Search
                      placeholder="请输入设备编号"
                      onSearch={() => this.handleSubmit(true)}
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={styles.formContainer}>
          <ReportTable
            page_num={page_num}
            data={this.props.reportStore.reportDate}
            onChangePage={this.onChangePage}
          />
        </div>
      </div>
    );
  }
}
const Report = Form.create()(ReportComponent);
export default Report;



// WEBPACK FOOTER //
// ./src/pages/Report/Report.js